import React from 'react';
import { Card, CardContent, Skeleton, Typography, Box } from '@mui/material';

interface KPICardProps {
  title: string;
  value: number | null;
  subtitle?: string;
  loading: boolean;
  icon?: React.ReactNode;
}

const numberFormatter = new Intl.NumberFormat('pt-BR');

const KPICard: React.FC<KPICardProps> = ({ title, value, subtitle, loading, icon }) => {
  const displayValue = () => {
    if (loading) {
      return <Skeleton variant="rectangular" width="60%" height={40} sx={{ borderRadius: 1 }} />;
    }
    if (value === null || value === undefined) {
      return (
        <Typography variant="h4" component="div" sx={{ fontWeight: 700 }}>
          --
        </Typography>
      );
    }
    return (
      <Typography variant="h4" component="div" sx={{ fontWeight: 700 }}>
        {numberFormatter.format(value)}
      </Typography>
    );
  };

  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
          {icon && (
            <Box sx={{ color: 'primary.main', display: 'flex', alignItems: 'center' }}>
              {icon}
            </Box>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ minHeight: 48, display: 'flex', alignItems: 'center' }}>
          {displayValue()}
        </Box>
        {subtitle && !loading && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
        {subtitle && loading && (
          <Skeleton variant="text" width="40%" sx={{ mt: 0.5 }} />
        )}
      </CardContent>
    </Card>
  );
};

export default KPICard;
